export default __webpack_public_path__ + "static/media/cart-filled.4d8f09a0.svg";